export const StatusChangeTypeEnum = {
  None: 0,
  Beneficial: 1,
  Adverse: 2,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/StatusChangeTypeEnum.js